export default __webpack_public_path__ + "static/media/606.a1f1df6e.png";